// get all
export const FLAG_GETTING_VOUCHER_TYPES = 'FLAG_GETTING_VOUCHER_TYPES';
export const SHOW_ERROR_GETTING_VOUCHER_TYPES = 'SHOW_ERROR_GETTING_VOUCHER_TYPES';
export const CLEAR_ERROR_GETTING_VOUCHER_TYPES = 'CLEAR_ERROR_GETTING_VOUCHER_TYPES';
export const GET_VOUCHER_TYPES = 'GET_VOUCHER_TYPES';
export const CLEAR_VOUCHER_TYPES = 'CLEAR_VOUCHER_TYPES';
